import ImpedidosDeContratar from "@/views/contratacao/ImpedidosDeContratar.vue";
import NovoImpedimento from "@/views/contratacao/EditarImpedimento.vue";
import DetalhesImpedimento from "@/views/contratacao/DetalhesImpedimento.vue";
import EditarImpedimento from "@/views/contratacao/EditarImpedimento.vue";
import SuspenderImpedimento from "@/views/contratacao/SuspenderImpedimento.vue";
import PerdasDeQualificacaoOscip from "@/views/contratacao/PerdasDeQualificacaoOscip.vue";
import NovaPerdaDeQualificacaoOscip from "@/views/contratacao/EditarPerdaDeQualificacaoOscip.vue";
import DetalhesPerdaDeQualificacaoOscip from "@/views/contratacao/DetalhesPerdaDeQualificacaoOscip.vue";
import EditarPerdaDeQualificacaoOscip from "@/views/contratacao/EditarPerdaDeQualificacaoOscip.vue";

const contratacaoRotas = [
  {
    path: "/contratacao/impedidos-de-contratar",
    name: "contratacao--impedidos-de-contratar",
    component: ImpedidosDeContratar,
  },
  {
    path: "/contratacao/novo-impedimento",
    name: "contratacao--novo-impedimento",
    component: NovoImpedimento,
  },
  {
    path: "/contratacao/detalhes-impedimento/:idImpedimento",
    name: "contratacao--detalhes-impedimento",
    component: DetalhesImpedimento,
    props: true,
  },
  {
    path: "/contratacao/editar-impedimento/:idImpedimento",
    name: "contratacao--editar-impedimento",
    component: EditarImpedimento,
    props: true,
  },
  {
    path: "/contratacao/suspender-impedimento/:idImpedimento",
    name: "contratacao--suspender-impedimento",
    component: SuspenderImpedimento,
    props: true,
  },
  {
    path: "/contratacao/perdas-de-qualificacao-oscip",
    name: "contratacao--perdas-de-qualificacao-oscip",
    component: PerdasDeQualificacaoOscip,
  },
  {
    path: "/contratacao/nova-perda-de-qualificacao-oscip",
    name: "contratacao--nova-perda-de-qualificacao-oscip",
    component: NovaPerdaDeQualificacaoOscip,
  },
  {
    path: "/contratacao/detalhes-perda-de-qualificacao-oscip/:idPerdaQualificacao",
    name: "contratacao--detalhes-perda-de-qualificacao-oscip",
    component: DetalhesPerdaDeQualificacaoOscip,
    props: true,
  },
  {
    path: "/contratacao/editar-perda-de-qualificacao-oscip/:idPerdaQualificacao",
    name: "contratacao--editar-perda-de-qualificacao-oscip",
    component: EditarPerdaDeQualificacaoOscip,
    props: true,
  },
];

export { contratacaoRotas };
